import moment from 'moment';
import { isEmptyObj } from '~utils/helpers';
import { filterOptions } from '~components/laws-filters/dates-filter/options';
// Полезные константы для использования в разных местах приложения
export const searchParams = {
    titleAndText: 'по названию и тексту',
    titleOnly: 'только по названию',
};

export const sortedBy = {
    publicationDate: 'Дата публикации',
    updates: 'Обновления',
};

export const sortFeed = {
    allPublications: 'Все публикации',
    favorites: 'Мое избранное',
    myActions: 'Мои действия',
    waitingForResponse: 'Ожидает ответа',
};

export const sortDigestsBy = {
    date: 'По дате',
    relevance: 'По релевантности',
};

export const displayDigestsAs = {
    grid: 'Сеткой',
    list: 'Списком',
};

export function computeRelativeDates(range) {
    let startDate = null;
    let endDate = null;

    if (range === filterOptions.week) {
        startDate = moment().subtract(1, 'week').startOf('date');
        endDate = moment().startOf('date');
    }
    if (range === filterOptions.month) {
        startDate = moment().subtract(1, 'month').startOf('date');
        endDate = moment().startOf('date');
    }
    if (range === filterOptions.threeMonths) {
        startDate = moment().subtract(3, 'month').startOf('date');
        endDate = moment().startOf('date');
    }
    if (range === filterOptions.halfYear) {
        startDate = moment().subtract(6, 'month').startOf('date');
        endDate = moment().startOf('date');
    }
    if (range === filterOptions.year) {
        startDate = moment().subtract(1, 'year').startOf('date');
        endDate = moment().startOf('date');
    }

    return { startDate, endDate };
}

export function computeDatesFilter(datesObj) {
    if (typeof datesObj !== 'object' || isEmptyObj(datesObj)) {
        return {
            startDate: null,
            endDate: null,
            range: '',
        };
    }
    const { startDate, endDate, range } = datesObj;
    let newStartDate = startDate ? startDate : null;
    let newEndDate = endDate ? endDate : null;

    if (range === filterOptions.week) {
        newStartDate = moment().subtract(1, 'week').startOf('date');
        newEndDate = moment().startOf('date');
    }
    if (range === filterOptions.month) {
        newStartDate = moment().subtract(30, 'days').startOf('date');
        newEndDate = moment().startOf('date');
    }
    if (range === filterOptions.threeMonths) {
        newStartDate = moment().subtract(3, 'month').startOf('date');
        newEndDate = moment().startOf('date');
    }
    if (range === filterOptions.halfYear) {
        newStartDate = moment().subtract(6, 'month').startOf('date');
        newEndDate = moment().startOf('date');
    }
    if (range === filterOptions.year) {
        newStartDate = moment().subtract(1, 'year').startOf('date');
        newEndDate = moment().startOf('date');
    }
    return {
        startDate: newStartDate,
        endDate: newEndDate,
        range,
    };
}

// Pащита от разных типов данных с бека
export function isSavedFilters(filters) {
    if (filters === null) {
        return false;
    }
    if (filters instanceof Object && isEmptyObj(filters)) {
        return false;
    }
    if (filters instanceof Object && !isEmptyObj(filters)) {
        return true;
    }
    if (typeof filters === 'undefined') {
        return false;
    }
    console.error('isSavedFilters: wrong argument type, expected one of types: null, Object, undefined');
    return false;
}



// WEBPACK FOOTER //
// ./src/utils/filters.js